import { parse } from "date-fns";
import TimePicker from "../../shared/form/fields/TimePicker";
import formatDate from "../../../helpers/formatDate";
import { Controller, useFormContext } from "react-hook-form";
import { isEmpty } from "lodash";

type ScheduleTimeFieldArgs = {
  name: string;
  dateName: string;
  allowEmpty?: boolean;
};

export default function ScheduleTimeField({
  name,
  dateName,
  allowEmpty = false,
}: ScheduleTimeFieldArgs) {
  const { control, watch } = useFormContext();
  const date = watch(dateName);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const time = !isEmpty(field.value)
          ? parse(
              field.value,
              "HH:mm",
              date ? new Date(date) : new Date(),
            ).toISOString()
          : undefined;

        return (
          <TimePicker
            name={field.name}
            value={time}
            onChange={(value) =>
              field.onChange(
                !isEmpty(value)
                  ? formatDate(new Date(value), "HH:mm")
                  : undefined,
              )
            }
            allowEmpty={allowEmpty}
          />
        );
      }}
    />
  );
}
